import Naluri from '~/common/api/naluri';
import {
  COMMON_GET_USER_CHANNEL_BEGIN,
  COMMON_GET_USER_CHANNEL_SUCCESS,
  COMMON_GET_USER_CHANNEL_FAILURE,
  COMMON_GET_USER_CHANNEL_DISMISS_ERROR,
  COMMON_GET_CHANNELS_SUCCESS,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getUserChannel(id, channelId = false) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_GET_USER_CHANNEL_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.

      const doRequest = channelId
        ? Naluri.get(`/api/expert/channel?channel_id=${id}`)
        : Naluri.get(`/api/expert/channel?user_id=${id}`);
      doRequest.then(
        res => {
          dispatch({
            type: COMMON_GET_USER_CHANNEL_SUCCESS,
            data: res,
          });
          resolve(res);

          if (!channelId) {
            dispatch({
              type: COMMON_GET_CHANNELS_SUCCESS,
              data: res,
            });
            resolve(res);
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: COMMON_GET_USER_CHANNEL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetUserChannelError() {
  return {
    type: COMMON_GET_USER_CHANNEL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_GET_USER_CHANNEL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getUserChannelPending: true,
        getUserChannelError: null,
      };

    case COMMON_GET_USER_CHANNEL_SUCCESS:
      // The request is success
      const newUsers = state.users.concat([action.data.users[0]]);
      const newChannels = state.channels.concat([action.data.channels[0]]);

      return {
        ...state,
        users: newUsers,
        channels: newChannels,
        getUserChannelPending: false,
        getUserChannelError: null,
      };

    case COMMON_GET_USER_CHANNEL_FAILURE:
      // The request is failed
      return {
        ...state,
        getUserChannelPending: false,
        getUserChannelError: action.data.error,
      };

    case COMMON_GET_USER_CHANNEL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getUserChannelError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/getUserChannel.js